/**
 * Typed client for the /api/feedback endpoint.
 *
 * Mirrors hy_sales/schemas/feedback.py — keep the types in lockstep
 * when the backend changes.
 */

import { apiPost } from './client';

export type FeedbackCategory = 'idea' | 'bug' | 'praise' | 'other';

export interface FeedbackSubmitRequest {
  category: FeedbackCategory;
  message: string;
  page_path?: string | null;
  allow_followup: boolean;
}

export interface FeedbackSubmitResponse {
  id: number;
  created_at: string;
  email_dispatched: boolean;
}

export function submitFeedback(payload: FeedbackSubmitRequest): Promise<FeedbackSubmitResponse> {
  return apiPost<FeedbackSubmitResponse>('sales', '/api/feedback', payload);
}
